export default "__VITE_ASSET__nTuA9r7K__"